import { Action, UserState, initialContextValue } from "../context/AppContext";
import { authConstants } from "../context/constants";

export const userReducer = (state: UserState, action: Action) => {
    try {
        switch (action.type) {
            case authConstants.LOGIN_REQUEST:
                return { 
                    ...state,
                    authenticating: true 
                }
            case authConstants.LOGIN_SUCCESS:
                return { 
                    ...action.payload,
                    authenticating: false,
                    authenticated: true,
                }
            case authConstants.LOGOUT:
                localStorage.removeItem("persistma");
                return {
                    authenticated: false,
                    authenticating: false,
                    logout: true
                }
            case authConstants.LOGIN_FAILURE: 
                return {
                    authenticating: false,
                    authenticated: false,
                    error: action.payload
                }
            case authConstants.RESTORE:
                return {
                    ...action.payload,
                    loaded: true
                }
            case authConstants.CHANGE_PROFILE:
                return {
                    ...state,
                    currentperfil: action.payload,
                }
            default: return state;
        }
    } catch (error) {
        localStorage.removeItem("persistma");
        return initialContextValue;
    }
}